module.exports = __webpack_public_path__ + "static/media/provider0@3x.996f4d11.png";